import { useMemo } from 'react';
import { useObjectStorageService } from '../Services/ObjectStorageService';
import UploadManager from '@cb/common-ts/UploadManager';
import { v4 as uuid } from 'uuid';
const defaultOptions = {
    usePresignedUrls: true,
    filePathPrefix: '',
};
export default class ObjectStorageUploadManager extends UploadManager {
    objectStorageService;
    options;
    constructor(objectStorageService, options) {
        super();
        this.objectStorageService = objectStorageService;
        this.options = {
            ...defaultOptions,
            ...options,
        };
    }
    prefixFilePathIfRequired(filePath) {
        if (filePath.startsWith(this.options.filePathPrefix)) {
            return filePath;
        }
        return this.options.filePathPrefix + (this.options.filePathPrefix.endsWith('/') ? '' : '/') + filePath;
    }
    makeUniqueFilePath(fileToUpload) {
        return this.prefixFilePathIfRequired(uuid() + '/' + fileToUpload.file.name);
    }
    getRedirectUrl(filePath) {
        return this.objectStorageService.getRedirectUrl(filePath);
    }
    getDownloadUrl(filePath) {
        return this.objectStorageService.getDownloadUrl(filePath);
    }
    async upload(fileToUpload) {
        fileToUpload.filePath = fileToUpload.filePath
            ? this.prefixFilePathIfRequired(fileToUpload.filePath)
            : this.makeUniqueFilePath(fileToUpload);
        if (this.options.usePresignedUrls) {
            await this.objectStorageService.uploadViaPresignedUrl(fileToUpload.filePath, fileToUpload.file);
        }
        else {
            await this.objectStorageService.upload(fileToUpload.filePath, fileToUpload.file);
        }
        return this.objectStorageService.getDownloadUrl(fileToUpload.filePath);
    }
}
export function useObjectStorageUploadManager(options) {
    const objectStorageService = useObjectStorageService();
    const objectStorageUploadManager = useMemo(() => {
        return new ObjectStorageUploadManager(objectStorageService, options);
    }, [objectStorageService, options]);
    return objectStorageUploadManager;
}
//# sourceMappingURL=ObjectStorageUploadManager.js.map